import { formatResponse, get, getApiEndpoint, transformApiUrl } from '../helpers/index.js';

class SizeService {
  constructor(client) {
    this.client = client;
    this.apiEndpoint = getApiEndpoint()+'size';
  }

  async all() {
    const action = 'read';
    this.apiEndpoint = transformApiUrl(this.apiEndpoint);
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { id: '' },
    });
    return formatResponse(getResponse);
  }

  async findById(id) {
    const action = 'read';
    const endpoint = `${this.apiEndpoint}/${action}`;
    const getResponse = await get(this.client, endpoint, {
      params: { id },
    });
    const [style] = formatResponse(getResponse);
    return style;
  }
}

export { SizeService as default };
